const Contact = () => {
  return (
    <>
      <h1>Contact Us</h1>
      <h2 className='mb-3'>Business Affairs and Consumer Protection (BACP)</h2>
      <p>
        The Department of Business Affairs and Consumer Protection provides
        resources to Chicago businesses that promote growth and success while
        ensuring the protection our community’s consumers. By providing
        bi-weekly and monthly informative sessions on best practices, the BACP
        facilitates economic vitality and vibrant communities all throughout the
        city. As part of this process, we license, educate, and regulate Chicago
        businesses while auditing various areas of business compliance. As of
        June 1, 2021, the City of Chicago requires short-term rental hosts
        register with the city before listing their property for rent on any
        licensed short-term residential rental platform. All short-term
        residential rental activities require approval from the BACP.
      </p>
      <h3>Office Information</h3>
      <p>
        Email:{' '}
        <a href='mailto:houseshares@cityofchicago.org'>
          houseshares@cityofchicago.org
        </a>
        <br />
        Phone: <a href='tel://312.744.6249'>312.744.6249</a>
        <br />
        TTY: <a href='312.744.1944'>312.744.1944</a>
        <br />
        Fax: <a href='312.744.0246'>312.744.0246</a>
        <br />
        121 N. LaSalle Street
        <br />
        8th Floor
        <br />
        Chicago, IL 60602
      </p>
    </>
  );
};

export default Contact;
